import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import ButtonPurple from 'components/design/Form/ButtonPurple'
import customLanguageTexts from '../../../language'
import './index.css'

const ModalCongratulations = () => {
  const settings = useSelector(state => state.settings)
  const apps = useSelector(state => state.apps)
  const user = useSelector(state => state.user)
  const [readyToRenderPopup, setReadyToRenderPopup] = useState(false)
  const [isMultiTenantApp, setIsMultiTenantApp] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    if (settings.showModalConfetti) {
      setTimeout(() => {
        dispatch({
          type: 'settings/CHANGE_SETTING',
          payload: {
            setting: 'showModalConfetti',
            value: false,
          },
        })
      }, 6000)
    }
  }, [settings, dispatch])

  useEffect(() => {
    if (
      apps.active.id &&
      apps.active.planName &&
      user.id &&
      user.pooledBilling !== undefined &&
      user.pooledBilling
    ) {
      setIsMultiTenantApp(true)
      setReadyToRenderPopup(true)
    } else if (apps.active.id && apps.active.planName && user.id) {
      setIsMultiTenantApp(false)
      setReadyToRenderPopup(true)
    }
  }, [apps.active, user.id, user.pooledBilling])

  const handleCancel = () => {
    if (apps?.appCreated?.id) {
      history.push(`/app/${apps.appCreated.id}/messaging-get-started`)
    }
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const { visibleModalID } = settings
  const modalID = 'congratulations'
  const visible = modalID === visibleModalID
  let modalContent = (
    <div>
      <div>{customLanguageTexts.APP_CONGRATULATIONS_MODAL_TITLE}</div>
    </div>
  )
  if (isMultiTenantApp) {
    modalContent = <div>Congratulations! Your new app has been successfully created.</div>
  }
  return (
    <>
      <Modal
        className="custom__success__modal app__created__modal"
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>Your App Is Ready</span>
            <img
              src="/resources/images/congrats.png"
              alt="congrats"
              style={{ width: 24, height: 24 }}
            />
          </div>
        }
        onCancel={handleCancel}
        afterClose={handleCancel}
        open={readyToRenderPopup && visible}
        footer={
          <div style={{ display: 'inline-flex' }}>
            <div style={{ maxWidth: '111px' }}>
              <ButtonPurple buttonText="Get Started" buttonType="button" onClick={handleCancel} />
            </div>
          </div>
        }
        maskClosable={false}
        style={{ padding: '0px' }}
      >
        <div className="p-0">{modalContent}</div>
      </Modal>
    </>
  )
}

export default ModalCongratulations
